import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
	selector: 'xp-section-header',
	standalone: true,
	imports: [NgIf],
	templateUrl: './xp-section-header.component.html',
	styleUrls: ['./xp-section-header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpSectionHeaderComponent {
	heading = input('');
	note = input('');
}
